var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('div',{staticClass:"filters__left"},[_vm._t("left")],2),_c('div',{staticClass:"filters__right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }